import { Button } from '@/shared/ui/Button';
import { Typography } from '@/shared/ui/Typography/Typography';
import * as React from 'react';
import Telegram from '@/assets/icons/telegram.svg?react';
import Whatsapp from '@/assets/icons/whatsapp.svg?react';
import { cn } from '@/shared/lib/utils';
import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { selectContacts } from '@/entities/home_content/model/selectors';
import { openFeedBackModal } from '@/shared/ui/Modal/model/slice';

export interface ITakePresentationProps {
  className?: string;
  presentationLink?: string | null;
}

export function TakePresentation(props: ITakePresentationProps) {
  const contacts = useAppSelector(selectContacts);
  const ButtonsRef = React.useRef<HTMLDivElement>(null);

  const dispatch = useAppDispatch();

  const handleShowPresentationDownloadModalWindow = (link: string) => {
    dispatch(
      openFeedBackModal({
        type: 'selection',
        link: link,
      })
    );
  };

  React.useEffect(() => {
    const container = ButtonsRef.current;

    if (!container) return;

    const middle = (container.scrollWidth - container.clientWidth) / 2;
    container.scrollLeft = middle;
  }, []);

  return (
    <section className={cn('w-full  py-[40px]', props.className)}>
      <div className="container flex flex-col px-[10px] md:px-[32px] xl:flex-row xl:gap-[20px] 2xl:px-[180px] 3xl:px-[290px]">
        <div className="flex flex-col gap-[20px] rounded-[30px] bg-[#10111A] py-[24px] md:py-[32px] xl:w-1/2 xl:gap-[32px] xl:py-[40px]">
          <div className="flex flex-col items-center gap-[20px] px-[20px] md:px-[24px] xl:gap-[32px] xl:px-[32px]">
            <Typography className="text-[20px] uppercase text-white md:text-[24px] xl:text-[26px]">
              Загрузите презентацию бц
            </Typography>

            <Typography className="text-center text-[16px] font-[400] text-white">
              Полная информация о самых интересных БЦ  — в одной презентации:
              точные планировки, фото готовых помещений, 3D-рендеры
              и технические характеристики. Скачайте, чтобы увидеть,
              как ваш бизнес может выглядеть здесь.
            </Typography>
          </div>

          <div
            ref={ButtonsRef}
            className="[::-webkit-scrollbar]:hidden flex items-center gap-[10px] overflow-x-auto px-[10px] [-ms-overflow-style:none] [scrollbar-width:none] md:mx-auto md:w-min md:flex-col"
          >
            <Button
              className="order-2 flex h-[43px] justify-center bg-white px-[24px] text-[16px] font-bold leading-[0.97em] text-black md:order-1 md:w-full"
              text="Скачать презентацию"
              onClick={() =>
                handleShowPresentationDownloadModalWindow(
                  props.presentationLink || ''
                )
              }
            />

            <a
              href={contacts?.telegramUrl}
              target="_blank"
              className="order-1 md:order-2"
            >
              <Button
                endIcon={<Telegram className="h-[23px] w-[23px]" />}
                text="Скачать презентацию в Telegram"
                className="h-[47px] gap-[12px] border border-white bg-[#FFFFFF33] p-[12px] pl-[16px] text-white md:w-full"
              />
            </a>

            <a
              href={contacts?.whatsappUrl}
              target="_blank"
              className="order-3 block md:hidden"
            >
              <Button
                startIcon={<Whatsapp className="h-[23px] w-[23px]" />}
                text="Скачать презентацию в WhatsApp"
                className="h-[47px] gap-[12px] border border-white bg-[#FFFFFF33] p-[12px] pl-[12px] text-white md:w-full"
              />
            </a>
            <a
              href={contacts?.whatsappUrl}
              target="_blank"
              className="order-3 hidden md:block"
            >
              <Button
                endIcon={<Whatsapp className="h-[23px] w-[23px]" />}
                text="Скачать презентацию в WhatsApp"
                className="h-[47px] gap-[12px] border border-white bg-[#FFFFFF33] p-[12px] pl-[16px] text-white md:w-full"
              />
            </a>
          </div>
        </div>

        <div className="hidden w-1/2 rounded-[30px] bg-[url(/images/knowledge_card_default_bg.jpg)] bg-cover bg-center xl:flex" />
      </div>
    </section>
  );
}
